import { render } from "./CustomKpiEditor.vue?vue&type=template&id=97ccb458&scoped=true"
import script from "./CustomKpiEditor.vue?vue&type=script&lang=ts"
export * from "./CustomKpiEditor.vue?vue&type=script&lang=ts"

import "./CustomKpiEditor.vue?vue&type=style&index=0&id=97ccb458&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97ccb458"

export default script